import { Tooltip, Legend } from "dependencies/bigScreen/publicChartOptions/options"
export const chartOption2 = {
  styleId:2,
  pluginName: [],
  refreshTime: 90000,
  internalDiameterRatio: 0,
  seriesTempAttributes: {
    // 用于存放数据中的通用配置项
    coordinateType: "" //不带坐标系
  },

  title: {
    text: "title",
    left: "center",
    show: false
  },
  tooltip: new Tooltip("item", {}),
  legend: new Legend({
    padding: [25, 0, 0, 0],
    data: ["数据1", "数据2", "数据3", "数据4", "数据5"],
    itemGap: 25,
    itemHeight: 7,
    itemWidth: 15,
    left: "center",
    top: "top",
    textStyle: {
      color: "rgba(255,255,255,1)",
      fontWeight: "400",
      fontSize: 14
    }
  }),
  xAxis3D: {
    min: -1,
    max: 1
  },
  yAxis3D: {
    min: -1,
    max: 1
  },
  zAxis3D: {
    min: -1,
    max: 1
  },
  grid3D: {
    show: false,
    boxHeight: 30,
    top: "0",
    left: "0",
    bottom: "80%",
    environment: "auto",
    viewControl: {
      distance: 300, //远近
      alpha: 50, //饼图X轴旋转   取值0-100比较合适
      beta: -10, //饼图Y轴旋转
      autoRotate: false, //旋转展示
      zoomSensitivity: false,
      rotateSensitivity: 0 //禁止按住鼠标拖动旋转
    }
  },
  series: [
    {
      type: "surface",
      itemStyle: {
        color: "rgb(0, 71, 255)",
        opacity: 1
      },
      tooltip: new Tooltip("item", { show: false }),
      name: "数据1",
      wireframe: {
        show: false
      },
      parametric: true,
      parametricEquation: {},
      pieData: {
        endRatio: 0.2,
        name: "数据1",
        startRatio: 0,
        value: 1
      },
      pieStatus: {
        hovered: false,
        k: -0.3333333333333333,
        selected: false
      }
      // labelLine: {
      //   lineStyle: { color: "rgba(214, 39, 176, 1)", width: 1, type: "solid" }
      // }
    },
    {
      type: "surface",
      itemStyle: {
        color: "rgb(0, 228, 228)",
        opacity: 1
      },
      tooltip: new Tooltip("item", { show: false }),
      name: "数据2",
      wireframe: {
        show: false
      },
      parametric: true,
      parametricEquation: {},
      pieData: {
        endRatio: 0.4,
        name: "数据2",
        startRatio: 0.2,
        value: 1
      },
      pieStatus: {
        hovered: false,
        k: -0.3333333333333333,
        selected: false
      },
      labelLine: {
        // lineStyle: { color: "rgba(192, 53, 227, 1)", width: 1, type: "solid" }
      }
    },
    {
      type: "surface",
      itemStyle: {
        color: "rgb(255, 166, 63)",
        opacity: 1
      },
      tooltip: new Tooltip("item", { show: false }),
      name: "数据3",
      wireframe: {
        show: false
      },
      parametric: true,
      parametricEquation: {},
      pieData: {
        endRatio: 0.6,
        name: "数据3",
        startRatio: 0.4,
        value: 1
      },
      pieStatus: {
        hovered: false,
        k: -0.3333333333333333,
        selected: false
      },
      labelLine: {
        // lineStyle: { color: "rgba(0, 71, 255, 1)", width: 1, type: "solid" }
      }
    },
    {
      type: "surface",
      itemStyle: {
        color: "rgb(214, 39, 176)",
        opacity: 1
      },
      tooltip: new Tooltip("item", { show: false }),
      name: "数据4",
      wireframe: {
        show: false
      },
      parametric: true,
      parametricEquation: {},
      pieData: {
        endRatio: 0.8,
        name: "数据4",
        startRatio: 0.6,
        value: 1
      },
      pieStatus: {
        hovered: false,
        k: -0.3333333333333333,
        selected: false
      },
      labelLine: {
        // lineStyle: { color: "rgba(0, 228, 228, 1)", width: 1, type: "solid" }
      }
    },
    {
      type: "surface",
      itemStyle: {
        color: "rgb(192, 53, 227)",
        opacity: 1
      },
      tooltip: new Tooltip("item", { show: false }),
      name: "数据5",
      wireframe: {
        show: false
      },
      parametric: true,
      parametricEquation: {},
      pieData: {
        endRatio: 1,
        name: "数据5",
        startRatio: 0.8,
        value: 1
      },
      pieStatus: {
        hovered: false,
        k: -0.3333333333333333,
        selected: false
      },
      labelLine: {
        // lineStyle: { color: "rgba(255, 166, 63, 1)", width: 1, type: "solid" }
      }
    },
    {
      name: "", //自己根据场景修改
      backgroundColor: "transparent",
      type: "pie",
      label: {
        show: false,
        opacity: 1,
        fontSize: 13,
        lineHeight: 20,
        fontWeight: "400",
        fontFamily: "sans-serif",
        color: "#fff",
        position: "inner",
        formatter: "{b}"
      },
      labelLine: {
        show: false,
        length: 50,
        length2: 10,
        lineStyle: { color: "rgba(255, 255, 255, 0.3)", width: 1, type: "solid" },
        smooth: 0.2
      },
      startAngle: 10, // 起始角度，支持范围[0, 360]。  与上方的viewControl   beta相关联
      clockwise: false, // 饼图的扇区是否是顺时针排布。上述这两项配置主要是为了对齐3d的样式
      radius: ["20%", "60%"],
      center: ["50%", "50%"],
      data: [
        {
          name: "数据1",
          value: 20,
          emphasis: {
            label: {
              show: true
            }
          }
        },
        {
          name: "数据2",
          value: 20,
          emphasis: {
            label: {
              show: true
            }
          }
        },
        {
          name: "数据3",
          value: 20,
          emphasis: {
            label: {
              show: true
            }
          }
        },
        {
          name: "数据4",
          value: 20,
          emphasis: {
            label: {
              show: true
            }
          }
        },
        {
          name: "数据5",
          value: 20,
          emphasis: {
            label: {
              show: true
            }
          }
        }
      ],
      itemStyle: {
        opacity: 0 //这里必须是0，不然2d的图会覆盖在表面
      }
    }
  ]
}
